import * as fromDatatype from '../datatype-library/index';

export interface bl_crm_address_book_member_link_RowInterface {
    guid:                        fromDatatype.GuidDataFieldInterface;
    address_book_guid:           fromDatatype.GuidDataFieldInterface;
    login_subject_guid:          fromDatatype.GuidDataFieldInterface;
    rank:                        fromDatatype.GuidDataFieldInterface;
    link_type:                   fromDatatype.GuidDataFieldInterface;
    created_date:                fromDatatype.TimestampTzDatatypeInterface;
    updated_date:                fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid:     fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:     fromDatatype.GuidDataFieldInterface;
    status:                      fromDatatype.VarcharDatatypeInterface;
    revision:                    fromDatatype.GuidDataFieldInterface;
    vrsn:                        fromDatatype.VarcharDatatypeInterface;

}

export class bl_crm_address_book_member_link_RowClass implements bl_crm_address_book_member_link_RowInterface {

    guid:                        fromDatatype.GuidDataFieldInterface;
    address_book_guid:           fromDatatype.GuidDataFieldInterface;
    login_subject_guid:          fromDatatype.GuidDataFieldInterface;
    rank:                        fromDatatype.GuidDataFieldInterface;
    link_type:                   fromDatatype.GuidDataFieldInterface;
    created_date:                fromDatatype.TimestampTzDatatypeInterface;
    updated_date:                fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid:     fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:     fromDatatype.GuidDataFieldInterface;
    status:                      fromDatatype.VarcharDatatypeInterface;
    revision:                    fromDatatype.GuidDataFieldInterface;
    vrsn:                        fromDatatype.VarcharDatatypeInterface;
  
  }
  